import { EventEmitter, Injectable } from '@angular/core';
import { Organization } from 'src/app/information/models/organization.model';
@Injectable()
export class OrganizationCreateService
{
    OrganizationEventEmiter:EventEmitter<Organization> = new EventEmitter<Organization>();
}